// Campo "Conta-nos a história da tua personalização" nas páginas de produto.
// Funciona com as duas apps (Customily e Globo): procura a caixa de texto cujo rótulo
// contém "Conta-nos a história" e:
//   MODO 'esconder' → tira-a da página (decisão do André, 02-09-2026: a história pede-se no email pós-compra)
//   MODO 'dobrar'   → esconde-a atrás de uma linha que abre ao tocar (versão-piloto, fica disponível)
// Só actua nos produtos da lista PILOTO; o aplicar.mjs --todos troca TODOS para true.
(function () {
  var MODO = 'esconder';
  var PILOTO = ['placa-spotify-personalizavel', 'caneca-line-art-animais', 'hoodie-mom-retrato-line-art-personalizado'];
  var TODOS = true;
  var ROTULO = /conta-nos a hist/i;
  var TEXTO = 'Queres contar-nos a história desta prenda? ❤️';

  var handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
  if (!handle) return;
  if (!TODOS && PILOTO.indexOf(handle) === -1) return;

  // Sobe pelos antepassados da caixa de texto até ao mais pequeno que inclua o rótulo.
  // Se esse antepassado tiver outros campos lá dentro, é grande demais: não se mexe.
  function contentorDoCampo(ta) {
    var c = ta.parentElement;
    for (var i = 0; i < 8 && c && c !== document.body; i++) {
      if (ROTULO.test(c.textContent || '')) {
        var outros = Array.prototype.filter.call(c.querySelectorAll('input, select, textarea'), function (e) {
          return e !== ta && e.type !== 'hidden';
        });
        return outros.length ? null : c;
      }
      c = c.parentElement;
    }
    return null;
  }

  function dobrar() {
    var caixas = document.querySelectorAll('textarea');
    for (var i = 0; i < caixas.length; i++) {
      var ta = caixas[i];
      if (ta.name === 'note' || ta.getAttribute('data-historia-dobrada')) continue;
      var cont = contentorDoCampo(ta);
      if (!cont) continue;
      ta.setAttribute('data-historia-dobrada', '1');
      if (ta.value && ta.value.trim()) continue; // o cliente já escreveu: fica aberto

      if (MODO === 'esconder') {
        cont.classList.add('historia-dobrada--fechado');
        continue;
      }

      var linha = document.createElement('button');
      linha.type = 'button';
      linha.className = 'historia-dobrada__linha';
      linha.textContent = TEXTO;
      linha.setAttribute('aria-expanded', 'false');
      cont.classList.add('historia-dobrada--fechado');
      cont.parentNode.insertBefore(linha, cont);
      linha.addEventListener('click', (function (c, l, t) {
        return function () {
          c.classList.remove('historia-dobrada--fechado');
          // A Customily repara que o campo ficou escondido e marca-o ela própria como oculto
          // (visually-hidden + display:none em linha). Ao abrir, limpa-se essa marca.
          if (c.style.display === 'none') c.style.display = '';
          if (c.getAttribute('visually-hidden') === 'true') c.removeAttribute('visually-hidden');
          l.remove();
          t.focus();
        };
      })(cont, linha, ta));
    }
  }

  // As apps desenham os campos depois da página carregar, por isso ouve-se tudo.
  var temporizador;
  function agendar() {
    clearTimeout(temporizador);
    temporizador = setTimeout(dobrar, 150);
  }
  document.addEventListener('DOMContentLoaded', agendar);
  window.addEventListener('customily-options-loaded', agendar);
  new MutationObserver(agendar).observe(document.documentElement, { childList: true, subtree: true });
  agendar();
})();
